/* Approved ROJO Halloween SMS appearance. No signup requests originate here. */
(()=>{
 if(window.__rojoHalloweenSMS)return;
 const instances=new Map();
 window.__rojoHalloweenSMS=(root)=>{
  if(!root||!root.hasAttribute('data-rojo-halloween-sms')||instances.has(root))return;
  if(!root.querySelector('[data-rojo-canvas]')||!root.querySelector('.rojo-promo-shell'))return;
 try {const tile=document.createElement('canvas');tile.width=180;tile.height=180;const c=tile.getContext('2d');if(c){let seed=27;const pixels=c.createImageData(180,180);for(let i=0;i<pixels.data.length;i+=4){seed=(seed*1664525+1013904223)>>>0;const v=seed>>>24;pixels.data[i]=v;pixels.data[i+1]=v*.7;pixels.data[i+2]=v*.6;pixels.data[i+3]=90;}c.putImageData(pixels,0,0);root.querySelector('.rh-grain').style.backgroundImage='url('+tile.toDataURL()+')';}}catch(_){}


 const source=root.querySelector('[data-rojo-canvas]');
 const shell=root.querySelector('.rojo-promo-shell');
 const ghostShell=shell.cloneNode(true);
 ghostShell.classList.add('rh-shell-ghost');ghostShell.setAttribute('aria-hidden','true');ghostShell.inert=true;
 [ghostShell,...ghostShell.querySelectorAll('*')].forEach(el=>{
  [...el.attributes].forEach(attr=>{if(attr.name==='id'||attr.name==='for'||attr.name==='name'||attr.name.startsWith('data-rojo'))el.removeAttribute(attr.name);});
  if(el.matches('input,select,button,textarea')){el.disabled=true;if(el.matches('input,textarea'))el.value='';}
  if(el.matches('[aria-live]'))el.removeAttribute('aria-live');
 });
 shell.appendChild(ghostShell);
 const ghost=document.createElement('canvas');ghost.className='rh-globe-breakup';ghost.setAttribute('aria-hidden','true');source.parentElement.appendChild(ghost);
 const tear=document.createElement('span');tear.className='rh-globe-tear';tear.setAttribute('aria-hidden','true');source.parentElement.appendChild(tear);
 const paint=ghost.getContext('2d');const frozen=document.createElement('canvas');const still=frozen.getContext('2d');
 const motion=matchMedia('(prefers-reduced-motion: reduce)');
 let reduced=motion.matches;
 let active=false,captured=false,mode=1,lastBurst=-10000,visible=false,disposed=false,running=false,homeReady=false,submitting=false,closed=false;
 const timers=new Set();
 const phases=new Set();
 const later=(fn,ms)=>{const timer=setTimeout(()=>{timers.delete(timer);if(!disposed&&root.isConnected)fn();},ms);timers.add(timer);return timer;};
 const phase=(fn,ms)=>{const timer=later(()=>{phases.delete(timer);fn();},ms);phases.add(timer);};
 const stopGlitch=()=>{active=false;captured=false;root.classList.remove('rh-disturbance','rh-freeze','rh-tracking');if(paint)paint.clearRect(0,0,ghost.width,ghost.height);};
 const clear=()=>{
  phases.forEach(timer=>{clearTimeout(timer);timers.delete(timer);});phases.clear();
  stopGlitch();running=false;
  root.classList.add('rh-cancelled');
  root.classList.remove('rh-sequence','rh-omen','rh-message-one','rh-message-two','rh-afterimage','rh-fading','rh-word-decay','rh-signup-active','rh-signup-impact','rh-contact-one','rh-contact-two','rh-contact-fading');
 };
 const editing=()=>root.contains(document.activeElement)&&document.activeElement.matches('input,select,textarea,button:not([data-rojo-world])');
 root._rhPaintGlitch=now=>{
  if(!active||!paint||!still||!visible||!homeReady)return;
  const width=source.width,height=source.height;
  if(ghost.width!==width||ghost.height!==height){ghost.width=width;ghost.height=height;frozen.width=width;frozen.height=height;captured=false;}
  if(!captured){still.clearRect(0,0,width,height);still.drawImage(source,0,0);captured=true;}
  const frame=mode===1?frozen:source;
  paint.clearRect(0,0,width,height);
  paint.globalAlpha=.22;paint.drawImage(frame,width*.055,-height*.009);paint.globalAlpha=1;
  const strips=mode===2?12:8;
  for(let i=0;i<strips;i++){
   const top=Math.floor(i*height/strips),bottom=Math.floor((i+1)*height/strips),h=bottom-top;
   const offset=(Math.sin(i*4.3+Math.floor(now/190)*1.8)*.07+(i%3===0?.065:-.02))*width;
   paint.drawImage(frame,0,top,width,h,offset,top,width,h);
   if(i===2||i===5){paint.fillStyle='rgba(15,0,9,.58)';paint.fillRect(0,top+Math.floor(h*.4),width,Math.max(2,Math.floor(h*.22)));}
  }
  let noiseSeed=Math.floor(now/240)+71;
  for(let i=0;i<14;i++){
   noiseSeed=(noiseSeed*1664525+1013904223)>>>0;
   const x=(noiseSeed%1000)/1000*width,y=((noiseSeed>>>10)%1000)/1000*height;
   paint.fillStyle=i%3===0?'rgba(171,26,58,.4)':'rgba(10,0,7,.46)';
   paint.fillRect(x,y,width*(.02+i%4*.015),Math.max(1,height*.005));
  }
 };
 const values=root.querySelectorAll('[data-rojo-promo-days],[data-rojo-promo-hours],[data-rojo-promo-minutes],[data-rojo-promo-seconds]');
 const echo=()=>values.forEach(value=>{value.dataset.echo=value.textContent;});echo();
 const mutation=new MutationObserver(echo);values.forEach(value=>mutation.observe(value,{childList:true,characterData:true,subtree:true}));
 const messageCountdown=root.querySelector('[data-rojo-promo-countdown]');
 const positionMessage=()=>{
  if(!root.isConnected||root.clientWidth>=900)return;
  const box=root.getBoundingClientRect();
  const globeBox=source.parentElement.getBoundingClientRect();
  const countdownBox=messageCountdown.getBoundingClientRect();
  if(globeBox.height<=0)return;
  const top=Math.ceil(Math.max(globeBox.top-box.top-3,countdownBox.bottom-box.top+5));
  root.style.setProperty('--rh-mobile-message-top',top+'px');
 };
 positionMessage();
 const burst=()=>{
  const now=performance.now();if(!homeReady||submitting||closed||root.classList.contains('rh-signup-active')||reduced||disposed||!root.isConnected||document.hidden||!visible||editing()||running||now-lastBurst<3400)return;
  lastBurst=now;running=true;
  positionMessage();
  root.classList.remove('rh-cancelled');
  root.classList.add('rh-sequence','rh-omen');
  phase(()=>{
   root.classList.remove('rh-omen');
   active=true;captured=false;mode=1;
   root.classList.add('rh-disturbance','rh-freeze');
  },340);
  phase(()=>root.classList.add('rh-message-one'),470);
  phase(()=>root.classList.add('rh-message-two'),850);
  phase(()=>{stopGlitch();root.classList.add('rh-afterimage');},1460);
  phase(()=>root.classList.add('rh-word-decay'),1910);
  phase(()=>root.classList.add('rh-fading'),2650);
  phase(clear,2780);
 };
 let started=false;
 const begin=()=>{if(started||reduced||!homeReady||!visible||closed)return;started=true;[1800,15700,31300,48900,67400].forEach(ms=>later(burst,ms));};
 const intersection=new IntersectionObserver(entries=>{visible=entries.some(entry=>entry.isIntersecting);if(visible&&homeReady)begin();else if(!visible)clear();},{threshold:.2});intersection.observe(root);
 const globe=root.querySelector('[data-rojo-world]');globe.addEventListener('click',burst);
 const focus=event=>{if(event.target.matches('input,select,textarea,button:not([data-rojo-world])'))clear();};root.addEventListener('focusin',focus);
 const hide=()=>{if(document.hidden)clear();};document.addEventListener('visibilitychange',hide);
 const motionChange=event=>{reduced=event.matches;if(reduced)clear();else if(visible)begin();};motion.addEventListener('change',motionChange);
 const resize=new ResizeObserver(()=>{captured=false;positionMessage();});resize.observe(source);resize.observe(root);resize.observe(messageCountdown);

 const form=root.querySelector('[data-rojo-rojomies-form]');
 const success=root.querySelector('[data-rojo-rojomies-success]');
 const formState=event=>{
  submitting=event.detail?.state==='submitting';
  clear();
  root.classList.toggle('rh-submitting',submitting);
  if(submitting)form?.setAttribute('aria-busy','true');
  else {
   form?.removeAttribute('aria-busy');
   root.classList.remove('rh-signed-up');
   if(success)success.style.minHeight='';
  }
 };
 const confirmed=()=>{
  clear();submitting=false;
  root.classList.remove('rh-submitting');root.classList.add('rh-signed-up');
  form?.removeAttribute('aria-busy');
  if(reduced||closed||!homeReady||!visible||document.hidden)return;
  active=true;captured=false;mode=2;
  root.classList.add('rh-signup-active','rh-signup-impact','rh-disturbance','rh-tracking');
  phase(()=>root.classList.add('rh-contact-one'),510);
  phase(()=>{stopGlitch();root.classList.remove('rh-signup-impact');},740);
  phase(()=>root.classList.add('rh-contact-two'),900);
  phase(()=>root.classList.add('rh-contact-fading'),1810);
  phase(clear,2630);
 };
 const expired=()=>{
  closed=true;submitting=false;clear();
  root.classList.remove('rh-submitting','rh-signed-up');
  form?.removeAttribute('aria-busy');
 };
 root.addEventListener('rojo:sms-state',formState);
 root.addEventListener('rojo:sms-success',confirmed);
 root.addEventListener('rojo:sms-closed',expired);
 const checkHome=()=>{
  const next=root.classList.contains('is-home')&&!root.classList.contains('is-app')&&!closed;
  if(next===homeReady)return;
  homeReady=next;
  if(homeReady&&visible){positionMessage();begin();}
  else if(!homeReady)clear();
 };
 const homeObserver=new MutationObserver(checkHome);
 homeObserver.observe(root,{attributes:true,attributeFilter:['class']});
 const dispose=()=>{
  if(disposed)return;
  disposed=true;clear();timers.forEach(clearTimeout);timers.clear();
  intersection.disconnect();mutation.disconnect();resize.disconnect();homeObserver.disconnect();removal.disconnect();
  document.removeEventListener('visibilitychange',hide);motion.removeEventListener('change',motionChange);
  root.removeEventListener('focusin',focus);globe.removeEventListener('click',burst);
  root.removeEventListener('rojo:sms-state',formState);root.removeEventListener('rojo:sms-success',confirmed);root.removeEventListener('rojo:sms-closed',expired);
  root.classList.remove('rh-submitting','rh-signed-up','rh-cancelled');
  ghostShell.remove();ghost.remove();tear.remove();delete root._rhPaintGlitch;
  instances.delete(root);
 };
 const removal=new MutationObserver(()=>{if(!root.isConnected)dispose();});
 if(root.parentNode)removal.observe(root.parentNode,{childList:true});
 instances.set(root,dispose);
 checkHome();
 };
 document.addEventListener("shopify:section:unload",event=>{
  for(const [root,dispose] of instances){if(!root.isConnected||event.target===root||event.target.contains(root))dispose();}
 });
})();
